// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"styles_infoWrapper__Jz3Tu","redText":"styles_redText__CVDoV"};